"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var package_details_model_1 = require("./package-details.model");
var PackageAvailability = (function (_super) {
    __extends(PackageAvailability, _super);
    function PackageAvailability() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageAvailability;
}(package_details_model_1.PackageDetails));
exports.PackageAvailability = PackageAvailability;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/licensing/package-availability.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/licensing/package-availability.model.js